{
  "light_off":[
    {"id":"post_off_1","author":"Mama Chidi","text":"Light don go again. Who has candle? I will pay in akara.","igbo":false},
    {"id":"post_off_2","author":"Tunde (No. 7)","text":"NEPA, we greet you. Please return what you borrowed.","igbo":false},
    {"id":"post_off_3","author":"Emeka Gen-Master","text":"Light is out. My generator is ready. Fuel not included o.","igbo":false},
    {"id":"post_off_4","author":"Aunty Ngozi","text":"Ndo to everybody in the dark. Hold your phone torch like a man.","gloss":"Ndo = sorry (sympathy).","igbo":true}
  ],
  "light_on":[
    {"id":"post_on_1","author":"Mama Chidi","text":"LIGHT DON COME! Everybody shout at once. Phone charging begins now.","igbo":false},
    {"id":"post_on_2","author":"Tunde (No. 7)","text":"Light is back. My fan is spinning. My faith is restored, for now.","igbo":false},
    {"id":"post_on_3","author":"Emeka Gen-Master","text":"Light is back. I am turning off my generator. Daalụ to everyone who suffered the noise.","gloss":"Daalụ = thank you.","igbo":true},
    {"id":"post_on_4","author":"Aunty Ngozi","text":"Quick, quick, plug everything in before it changes its mind.","igbo":false}
  ]
}
